import Immutable from 'seamless-immutable';

import { SETTING_LIST_REQUEST, SETTING_LIST_SUCCESS, SETTING_LIST_ERROR } from 'Actions/setting';

export const INITIAL_STATE = Immutable({
    loading: false,
    success: false,
    error: false,
    filter: {},
    data: [],
    metadata: {},
});

export default function packListReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SETTING_LIST_REQUEST:
            return state.merge({
                loading: true,
                success: false,
                error: false,
            });

        case SETTING_LIST_SUCCESS: {
            return state.merge({
                loading: false,
                success: true,
                error: false,
                data: action.payload.data,
                metadata: action.payload.metadata,
            });
        }

        case SETTING_LIST_ERROR:
            return state.merge({
                loading: false,
                success: false,
                error: true,
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/settingsListReducer.js